import { TApiParameter } from "../../api/endpoints/Parameter";
import { IFetchParametersCompletedAction, PARAMETERS_FETCH_COMPLETED } from "../action-creators/parameters";

type TParametersState = {
  loading: boolean;
  loadedAt: null | number;
  error: null | Error;
  data: {
    [shortname: string]: TApiParameter
  }
}

const initialState = {
  loading: false,
  loadedAt: null,
  error: null,
  data: {}
};

type TAllowedActions = IFetchParametersCompletedAction;

const transformByShortname = (params: Array<TApiParameter>): TParametersState['data'] => {
  return params.reduce((acc, param) => {
    acc[param.shortname] = param;

    return acc;
  }, {} as TParametersState['data'])
}

const parametersReducer = (state: TParametersState = initialState, action: TAllowedActions) => {
  switch (action.type) {
    case PARAMETERS_FETCH_COMPLETED:
      return {
        ...state,
        loading: false,
        loadedAt: Date.now(),
        error: null,
        data: transformByShortname(action.data)
      }


    default:
      return state;
  }
}

export default parametersReducer;
